/**
 * Parts / Accessories / Clothing top nav — open mega menu only, no parent collection page.
 */
(function () {
  function inHeaderMenu(el) {
    return el?.closest?.(".menu-list, .menu-drawer, .menu-list--mobile");
  }

  document.addEventListener(
    "click",
    (event) => {
      const anchor = event.target.closest?.('a[href="#"]');
      if (!anchor || !inHeaderMenu(anchor)) return;
      event.preventDefault();
    },
    true
  );

  document.addEventListener(
    "click",
    (event) => {
      const anchor = event.target.closest?.(".menu-drawer a[href='#']");
      if (!anchor) return;
      event.preventDefault();
    },
    true
  );

  keepMegaMenuOverWhitePanel();

  function keepMegaMenuOverWhitePanel() {
    const CLOSE_MS = 280;
    let pointer = { x: 0, y: 0 };

    document.addEventListener(
      "pointermove",
      (event) => {
        pointer.x = event.clientX;
        pointer.y = event.clientY;
      },
      { passive: true }
    );

    function overWhitePanel() {
      const el = document.elementFromPoint(pointer.x, pointer.y);
      if (!el) return false;
      return Boolean(
        el.closest(".menu-list__submenu") ||
          el.closest(".header__underlay-open") ||
          el.closest("header-menu .menu-list__link[aria-expanded='true']")
      );
    }

    customElements.whenDefined("header-menu").then(() => {
      const proto = customElements.get("header-menu")?.prototype;
      if (!proto || proto.__zcKeepWhitePanel || typeof proto.deactivate !== "function") return;
      proto.__zcKeepWhitePanel = true;

      const originalDeactivate = proto.deactivate;
      proto.deactivate = function (event) {
        if (!window.matchMedia("(hover: hover) and (min-width: 750px)").matches) {
          return originalDeactivate.call(this, event);
        }
        clearTimeout(this.__zcDeactivateTimer);
        this.__zcDeactivateTimer = setTimeout(() => {
          if (overWhitePanel()) return;
          originalDeactivate.call(this, event);
        }, CLOSE_MS);
      };
    });
  }
})();
